module["exports"] = [
  "GmbH",
  "AG",
  "Gruppe",
  "KG",
  "GmbH & Co. KG",
  "UG",
  "OHG"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/company/legal_form.js
// module id = 970
// module chunks = 0